import { Paragraph1, Paragraph2 } from 'inpock-ui-react';
import styled from '@emotion/styled';

const Container = styled.section<{ height: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  padding-bottom: 80px;
  height: ${(props) => (props.height ? `${props.height}px` : '250px')};
`;

export function EmptyResult(props: { subTitle: string; height?: number }) {
  return (
    <Container height={props.height ?? 0}>
      <Paragraph1 style={{ marginBottom: '8px' }}>검색 결과가 없습니다</Paragraph1>
      <Paragraph2 color="gray600" style={{ marginBottom: '8px' }}>
        {props.subTitle}
      </Paragraph2>
    </Container>
  );
}
